import RemoteIcon from '@/components/RemoteIcon/RemoteIcon';
import type {InfoBannerModel} from '@/types/aem';
import {twx} from '@/utils/tailwindUtils';

type InfoBannerProps = {
    content?: InfoBannerModel | null;
    className?: string;
};

const InfoBanner = ({content, className}: InfoBannerProps) => {
    if (!content) return null;

    const {icon, title, description} = content;

    return (
        <div className={twx('flex flex-col items-center gap-2 text-center', className)}>
            {icon && <RemoteIcon icon={icon} className='size-16' />}
            {title && <p className='m-0 font-bold text-28 text-romance leading-143'>{title}</p>}
            {description && <p className='m-0 text-16 text-romance leading-15'>{description}</p>}
        </div>
    );
};

export default InfoBanner;
